import {tns} from 'tiny-slider/src/tiny-slider'

class Carousels {
    constructor() {

        this.testimonialCarousels = document.querySelectorAll('.testimonials-carousel');
        if (this.testimonialCarousels.length > 0) {
            this.initTestimonialCarousels();
        }

        this.postsCarousels = document.querySelectorAll('.posts-carousel');
        if (this.postsCarousels.length > 0) {
            this.initPostsCarousels();
        }


    }


    initTestimonialCarousels() {
        this.testimonialCarousels.forEach((carouselInstance) => {

            const itemsContainer = carouselInstance.querySelector('.testimonials-carousel__wrapper');


            const carousel = tns({
                "container": itemsContainer,
                "items": 1,
                "slideBy": "page",
                "autoplay": false,
                "autoplayTimeout": 12000,
                "autoplayButton": false,
                "autoplayButtonOutput": false,
                "mouseDrag": true,
                "loop": false,
                'nav': false,
                'navPosition': 'bottom',
                'controls': false,
                'autoHeight': true,
                "responsive": {
                    "350": {
                        "items": 1,
                    },
                    "760": {
                        "items": 2,
                    },
                },
            });


            const items = itemsContainer.querySelectorAll('.testimonials-carousel__item');


            items.forEach((item) => {


                const excerpt = item.querySelector('.testimonials-carousel__excerpt');
                const expandButton = item.querySelector('.testimonials-carousel__expand');
                const full = item.querySelector('.testimonials-carousel__full');


                if (expandButton != null) {

                    expandButton.addEventListener('click', () => {
                        excerpt.classList.add('hidden');
                        full.classList.remove('hidden');
                        expandButton.classList.add('hidden');

                        carousel.updateSliderHeight();

                    })
                }

            })


        });
    }

    initPostsCarousels() {
        this.postsCarousels.forEach((carouselInstance) => {

            const items = carouselInstance.querySelector('.posts-carousel__wrapper');

            tns({
                "container": items,
                "items": 1,
                "slideBy": "page",
                "autoplay": true,
                "autoplayTimeout": 12000,
                "autoplayButton": false,
                "autoplayButtonOutput": false,
                "mouseDrag": true,
                "loop": true,
                'nav': true,
                'navPosition': 'bottom',
                'controls': false,
                'autoHeight': true,
            });

        });
    }
}

export default Carousels;